import { Component, OnInit, ViewChild, ElementRef, KeyValueChanges } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import { AuditService } from '../../services/audit.service';
import { Audit } from '../../models/audit';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { NgForm } from '@angular/forms';
import { Country } from '../../models/country';
import { AuditCtgc } from '../../models/auditCtgc';
import { AppConfigService } from '../../config/app-config.service';
import { debounceTime } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../../services/user.service';
declare var require: any;

@Component({
    selector: 'app-countriesAuditLogs',
    templateUrl: './countriesAuditLogs.component.html',
    styleUrls: ['countriesAuditLogs.component.css']
})
export class CountriesAuditLogsComponent implements OnInit {

    countryList: Country[] = [];
    AuditList: Audit[] = [];
    AuditCtgcList: AuditCtgc[] = [];

    conflictsList: number[];
    auditTypeList: string[];

    selectedAuditType: string;
    selectedCountryId: string;
    dateFrom: string = new Date().toISOString().substring(0, 11) + '00:00';
    dateSince: string;
    today: string;
    fileselected: string;
    labelConflictsText: string;
    hasResult: boolean = false;

    amountDaysCountryAuditLogs: number;
    selectedAuditId: number;
    selectedAuditCtgcId: number;

    isDisabled: boolean = false;

    public seedsVersion: string;

    constructor(private translate: TranslateService, public userService: UserService, private service: AuditService, private toastr: ToastrService, private authService: AuthService,
        private spinner: NgxSpinnerService, private appSettings: AppConfigService, private auditRoute: ActivatedRoute) {

        this.amountDaysCountryAuditLogs = this.auditRoute.snapshot.params.amountDaysCountryAuditLogs;
    }

    //grid psgk
    dataSourceAudit = new MatTableDataSource<Audit>();
    displayedColumnsAudit: string[] = ['int_country_code', 'des_country_name', 'bol_activated', 'bol_test_lock', 'oid_log', 'oid_request', 'int_operation_type', 'int_operation_origin', 'des_key',
        'int_delay', 'bol_force_closure', 'des_dispatcher_id', 'des_dispatcher_password', 'cod_country', 'cod_user_culture', 'des_source', 'des_user', 'des_employee1_id', 'des_employee1_password',
        'des_employee2_id', 'des_employee2_password', 'des_machine', 'int_lock_model', 'des_lock_id', 'int_child_lock_code', 'des_physical_key1', 'des_physical_key2', 'des_asset_id', 'des_serial_number',
        'des_closure_code', 'bol_code_accepted', 'bol_activation_confirmation', 'bol_open_forced_closure_confir', 'des_original_operation_id', 'bol_lock_active_only', 'dtm_request_date_time',
        'dtm_response_date_time', 'des_generated1_code', 'des_generated2_code', 'des_operation1_id', 'des_operation2_id', 'int_operation_confirmation', 'bol_duress', 'des_errors', 'des_employee1_encryption_code',
        'des_employee2_encryption_code', 'lock_identifier', 'int_asset_type', 'des_branch_code', 'oid_route', 'des_route_code', 'dat_route_date', 'bol_direct_opening', 'bol_success', 'des_dispatcher_name'];
    @ViewChild('PsgkPaginator', { static: true }) PsgkPaginator: MatPaginator;
    @ViewChild('PsgkSort', { static: true }) PsgkSort: MatSort;
    isLoading = true;
    selection = new SelectionModel<Audit>(true, []);
    selectionCtgc = new SelectionModel<AuditCtgc>(true, []);

    //grid ctgc
    dataSourceAuditCtgc = new MatTableDataSource<AuditCtgc>();
    displayedColumnsAuditCtgc: string[] = ['action', 'datetime', 'detail', 'id', 'result', 'source', 'usr', 'des_country_name', 'int_country_code'];
    @ViewChild('CtgcPaginator', { static: true }) CtgcPaginator: MatPaginator;
    @ViewChild('CtgcSort', { static: true }) CtgcSort: MatSort;
    isLoadingCtgc = true;

    @ViewChild('fileInput') fileInput: ElementRef;

    filterValues: any = {};

    selectedRowIndex: any;
    readonly = false;
    objAudit = new Audit();

    ngOnInit(): void {
        this.setDefaultValues(true);
    }

    setDefaultValues(isLoadingPage) {

        this.setDefinitions();

        if (this.auditRoute.snapshot.params.idCountry == "0")        
            //utiliza fecha de AmountDaysCountryAuditLogs días atrás
            this.dateFrom = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24 * this.amountDaysCountryAuditLogs).toISOString().substring(0, 11) + '00:00';

        this.dateSince = new Date().toISOString().substring(0, 11) + '23:59';

        this.fillCountryList(isLoadingPage);
    }

    setDefinitions() {
        let user =  this.authService.getUserFromToken();
        
                if (user.roleID == 2) {
                    this.selectedCountryId = user.country.id.toString();
                    this.isDisabled = true;
                    this.auditTypeList = ["COUNTRY_AUDIT_LOGS.PSGK_AUDIT",
                                         "COUNTRY_AUDIT_LOGS.CTGC_AUDIT"];
                }
                else {
                    this.selectedCountryId = this.auditRoute.snapshot.params.idCountry;

                    this.auditTypeList = ["COUNTRY_AUDIT_LOGS.PSGK_AUDIT",
                                          "COUNTRY_AUDIT_LOGS.CTGC_AUDIT",
                                          "COUNTRY_AUDIT_LOGS.PSGK_AUDIT_CONFLICTS",
                                          "COUNTRY_AUDIT_LOGS.CTGC_AUDIT_CONFLICTS"];
                }

                this.selectedAuditType = this.auditTypeList[0].toString();
           
    }  

    onSubmit() {
        this.showGrids("hide");

        if (!this.fieldsValidation()) {
            this.toastr.warning(this.translate.instant("COUNTRY_AUDIT_LOGS.MSG_MANDATORY_FIELDS"));
            this.showGrids("hide");
        }
        else if (this.selectedAuditType == "COUNTRY_AUDIT_LOGS.PSGK_AUDIT" || this.selectedAuditType == "COUNTRY_AUDIT_LOGS.PSGK_AUDIT_CONFLICTS")
            this.fillGridPSGK();
        else 
            this.fillGridCtgc();
        
    }

    showGrids(grid) {

        let elemGridPSGK: HTMLElement = document.getElementById('gridPSGK');
        let elemGridCtgc: HTMLElement = document.getElementById('gridCtgc');

        switch (grid) {
            case "psgk":
                elemGridPSGK.setAttribute("style", "display:block;");
                elemGridCtgc.setAttribute("style", "display:none;");
                break;
            case "ctgc":
                elemGridPSGK.setAttribute("style", "display:none;");
                elemGridCtgc.setAttribute("style", "display:block;");
                break;
            default:
                elemGridPSGK.setAttribute("style", "display:none;");
                elemGridCtgc.setAttribute("style", "display:none;");
                this.labelConflictsText = "";
                break;
        }
    }

    fieldsValidation(): boolean {
        if ((this.selectedCountryId == null || this.selectedCountryId == "") ||
            (this.selectedAuditType == null || this.selectedAuditType == "") ||
            (this.dateFrom == null || this.dateFrom == "") ||
            (this.dateSince == null || this.dateSince == ""))
            return false;
        else
            return true;
    }

    fillCountryList(isLoadingPage) {

        this.spinner.show();

        this.service.getCountriesList().subscribe(
            data => {
                this.countryList = data;

                //si es 0 selecciona el primero del listado
                if (this.selectedCountryId == "0")
                    this.selectedCountryId = data[0].id.toString();
                
                if (this.auditRoute.snapshot.params.idCountry != "0")
                {
                    this.dateFrom = this.countryList.find(i => i.id.toString() === this.auditRoute.snapshot.params.idCountry).lastTest.toString().substring(0, 11) + '00:00';                  
                }


                
                this.spinner.hide();

                if (isLoadingPage)
                    this.onSubmit();
            },
            error => {                
                this.spinner.hide();
            }
        );
    }

    fillGridPSGK() {
        this.spinner.show();
        this.isLoading = true;

        this.service.getAuditList(this.selectedCountryId.toString(), this.dateFrom, this.dateSince, this.auditTypeList.indexOf(this.selectedAuditType).toString(),
            this.authService.getLoginFromToken()).pipe(debounceTime(800)).subscribe(
                res => {
                    this.isLoading = false;

                    this.AuditList = res;

                    if (this.AuditList.length == 0) {
                        this.emptySearch();
                        this.hasResult = false;
                    }
                    else {
                        this.showGrids("psgk");
                        this.fillConflicts();
                        this.hasResult = true;
                    }

                    this.dataSourceAudit = new MatTableDataSource<Audit>();
                    this.dataSourceAudit.data = res as [];
                    this.dataSourceAudit.sort = this.PsgkSort;
                    this.dataSourceAudit.paginator = this.PsgkPaginator;
                    this.dataSourceAudit.paginator._intl.itemsPerPageLabel = this.translate.instant("REG.ITEMS_PER_PAGE");
                },
                err => {
                    this.selection = new SelectionModel<Audit>(true, []);
                    this.spinner.hide();
                }
            );
    }

    fillConflicts() {

        this.service.GetAuditLogCountryConflicts(this.selectedCountryId.toString(), this.dateFrom, this.dateSince, this.authService.getLoginFromToken()).pipe(debounceTime(800)).subscribe(
            res => {
                this.conflictsList = res;
                this.labelConflictsText = this.translate.instant("COUNTRY_AUDIT_LOGS.PSGK_AUDIT_CONFLICTS") + " = " + res[0].toString() + " | " +
                                            this.translate.instant("COUNTRY_AUDIT_LOGS.CTGC_AUDIT_CONFLICTS") + " = " + res[1].toString();
                this.spinner.hide();
            },
            err => {            
                this.spinner.hide();
            }
        );
    }

    emptySearch() {
        this.showGrids("hide");
        //this.toastr.warning(this.translate.instant("COUNTRY_AUDIT_LOGS.EMPTY_DATA"));
        this.spinner.hide();
    }

    fillGridCtgc() {
        this.spinner.show();
        this.isLoadingCtgc = true;

        this.service.getAuditListCtgc(this.selectedCountryId.toString(), this.dateFrom, this.dateSince, this.auditTypeList.indexOf(this.selectedAuditType).toString(),
            this.authService.getLoginFromToken()).subscribe(
                res => {
                    this.isLoadingCtgc = false;

                    this.AuditCtgcList = res;

                    if (this.AuditCtgcList.length == 0) {
                        this.emptySearch();
                        this.hasResult = false;
                    }
                    else {
                        this.showGrids("ctgc");
                        this.fillConflicts();
                        this.hasResult = true;
                    }

                    this.dataSourceAuditCtgc = new MatTableDataSource<AuditCtgc>();
                    this.dataSourceAuditCtgc.data = res as [];
                    this.dataSourceAuditCtgc.sort = this.CtgcSort;
                    this.dataSourceAuditCtgc.paginator = this.CtgcPaginator;
                    this.dataSourceAuditCtgc.paginator._intl.itemsPerPageLabel = this.translate.instant("REG.ITEMS_PER_PAGE");
                    this.spinner.hide();
                },
                err => {
                    this.selectionCtgc = new SelectionModel<AuditCtgc>(true, []);
                }
            );
    }

    selectAuditRow(id) {
        this.selectedRowIndex = id;
        this.selectedAuditId = Number(id);
    }

    selectAuditCtgcRow(id) {
        this.selectedRowIndex = id;
        this.selectedAuditCtgcId = Number(id);
    }

    resetForm(form: NgForm) {
        this.setDefaultValues(false);

        this.readonly = false;
        this.AuditList = this.dataSourceAudit.data;
        this.AuditCtgcList = this.dataSourceAuditCtgc.data;

        this.showGrids("hide");
    }

    openDialog(): void {
        let event = new MouseEvent('click', { bubbles: false });
        this.fileInput.nativeElement.value = "";
        this.fileInput.nativeElement.dispatchEvent(event);
    }

    uploadFiles(files) {

        this.spinner.show();

        if (files.length === 0)
            return;

        const formData = new FormData();

        for (let file of files)
            formData.append(file.name, file);

        this.service.uploadFiles(formData).subscribe(
            event => {
                if (event.type === HttpEventType.Response) {
                    this.toastr.success(this.translate.instant("ADMIN.UPLOAD") + " " + this.translate.instant("COM.SUCCESSFUL"), '');
                    this.onSubmit();
                }   
            },
            err => {                 
                this.spinner.hide();
            }
        );
    }

    ExportAudit() {
        this.spinner.show();
        this.service.ExportAuditCountry(this.authService.getLoginFromToken(), this.auditTypeList.indexOf(this.selectedAuditType).toString(), this.dateFrom, this.dateSince, this.selectedCountryId.toString())
            .subscribe((result: any) => {

                if (result.type != 'text/plain') {
                    var blob = new Blob([result]);
                    let saveAs = require('file-saver');
                    let date = new Date();

                    let file = "Audit-" + date.toISOString() + ".xlsx";
                    saveAs(blob, file);
                    this.spinner.hide()
                    this.toastr.success("", this.translate.instant("ADMIN.DOWNLOAD") + " " + this.translate.instant("COM.SUCCESSFUL"))
                }
                else {
                    this.spinner.hide()
                    this.toastr.error("", this.translate.instant("ADMIN.NO_DATA"));
                }
            },
                err => {

                    this.spinner.hide();

                }
            )
      }
}
